import Modal from 'modal-react-native-web';
export { Modal };
//# sourceMappingURL=Modal.web.js.map